<template>
  <div :data-id-group="idGroup" class="collapse-group relative wp-100" :class="{'pl-33 timeline': isTimeline}" v-bind="$attrs">
    <slot />
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useCollapse } from './useCollapse'

export default {
  name: 'CollapseGroup',
  props: {
    accordion: {
      type: Boolean,
      default: false,
    },
    toggleAllPanelExpand: {
      type: Boolean,
      default: false,
    },
    groupName: {
      type: String,
      required: true,
    },
    isTimeline: {
      type: Boolean,
      default: false,
    }
  },
  setup(props) {
    const idGroup = ref(`group-${props.groupName}`)
    const { setGroupAccordionStatus, toggleAllPanelExpandedStatus } =
      useCollapse()

    watch(
      () => props.toggleAllPanelExpand,
      (value) => {
        toggleAllPanelExpandedStatus(idGroup.value, value)
      },
    )

    setGroupAccordionStatus(idGroup.value, props.accordion)

    return {
      idGroup,
    }
  },
}
</script>

<style lang="scss" scoped>
.collapse-group.timeline {
  &:before {
    content: '';
    position: absolute;
    top: 50px;
    bottom: 50px;
    left: 12px;
    right: auto;
    box-sizing: border-box;
    width: 1px;
    border-left: 1px dashed #a4cbfa;
  }
}
</style>
